var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.success
      ? _c("div", { staticStyle: { "min-height": "500px" } }, [
          _vm.finalQuestionnaire
            ? _c("div", [
                _c("h1", [
                  _vm._v("Vielen Dank für deine abschließende Meinung")
                ]),
                _vm._v(" "),
                _vm._m(0)
              ])
            : _c("div", [
                _c("h2", [_vm._v("Vielen Dank für deine Teilnahme")]),
                _vm._v(" "),
                _c("div", [
                  _vm._v(
                    "Damit hilfst du uns, brands you love noch besser zu machen."
                  ),
                  _c("br"),
                  _c("br"),
                  _vm._v("\nViele Grüße"),
                  _c("br"),
                  _vm._v("\ndein brands you love-Team")
                ])
              ])
        ])
      : _vm._e(),
    _vm._v(" "),
    !_vm.success
      ? _c(
          "div",
          [
            _vm.elementsLoaded
              ? _c("question-list", {
                  ref: "questionList",
                  attrs: { questions: _vm.survey.questionnaire.questionList }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.hasError && !_vm.hasErrorMessage
              ? _c(
                  "div",
                  { staticClass: "errorBox", attrs: { id: "errorbox" } },
                  [
                    _c("strong", [
                      _vm._v("Bitte korrigiere die markierten Fragen")
                    ])
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.hasError && _vm.hasErrorMessage
              ? _c(
                  "div",
                  { staticClass: "errorBox", attrs: { id: "errorbox" } },
                  [_c("strong", [_vm._v(_vm._s(_vm.errorMessage))])]
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn btn-white teaserButton width100",
                staticStyle: { "margin-top": "20px" },
                on: { click: _vm.saveSurvey }
              },
              [_vm._v("SPEICHERN")]
            )
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticStyle: { "margin-top": "15px", "font-family": "Roboto" } },
      [
        _vm._v(
          "Wir freuen uns über deinen Beitrag zu unserer Aktion!\n\t\t\t\t"
        ),
        _c("br"),
        _c("br"),
        _vm._v(
          "\n\t\t\t\tSobald das Ergebnis der Umfrage feststeht, bekommst du eine Info von uns."
        ),
        _c("br"),
        _vm._v(
          "\n\t\t\t\tWir würden uns freuen, wenn wir dich bei einer künftigen Aktion bald wiedersehen. Schau doch am Besten gleich nach – vielleicht interessiert dich ja schon wieder etwas! "
        ),
        _c("a", { attrs: { href: "/allProjects.html" } }, [
          _vm._v("Alle Aktionen")
        ]),
        _vm._v(" "),
        _c("br"),
        _c("br"),
        _vm._v("\n\t\t\t\tViele Grüße"),
        _c("br"),
        _vm._v("\n\t\t\t\tdein brands you love-Team")
      ]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-74fd2ee2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-74fd2ee2","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Survey.vue
// module id = 590
// module chunks = 2